import React, { useEffect, useState } from 'react';
import { Clock3 } from 'lucide-react';
import { estadoHorarioCatalogo, agruparHorarioSemanal } from '../../dominio/horarioCatalogo';
import '../../estilos/horarioCatalogo.css';

export const EstadoHorarioCatalogo = ({ horarioSemanal, horario = '' }) => {
  const [ahora, setAhora] = useState(() => new Date());
  useEffect(() => {
    if (!horarioSemanal?.length) return undefined;
    let reloj;
    const actualizar = () => {
      clearTimeout(reloj);
      if (document.visibilityState === 'hidden') return;
      setAhora(new Date());
      // Solo reloj local: no Firestore, Cloud Functions, ni solicitudes HTTP.
      reloj = setTimeout(actualizar, 60000 - Date.now() % 60000 + 50);
    };
    actualizar();
    document.addEventListener('visibilitychange', actualizar);
    window.addEventListener('focus', actualizar);
    return () => { clearTimeout(reloj); document.removeEventListener('visibilitychange', actualizar); window.removeEventListener('focus', actualizar); };
  }, [horarioSemanal]);
  const estado = estadoHorarioCatalogo(horarioSemanal, ahora);
  return <span className={`catalogo-horario-estado ${estado.abierto === false ? 'is-cerrado' : ''}`}
    title="Horario de atención en Perú; no representa disponibilidad de stock ni validación de pago">
    <Clock3 size={14} /> {estado.etiqueta || horario || 'Consulta los horarios con el gimnasio'}
  </span>;
};

export const HorarioSemanalCatalogo = ({ horarioSemanal, horario = '' }) => {
  let dias;
  try { dias = agruparHorarioSemanal(horarioSemanal); } catch { dias = []; }
  if (!dias.length) return <p>{horario || 'Consulta los horarios vigentes con el gimnasio.'}</p>;
  return <details className="horario-desplegable"><summary>Ver horario semanal</summary>
    <dl className="catalogo-horario-lista" aria-label="Horario semanal, hora de Perú">
    {dias.map(grupo => <div key={grupo.dias}><dt>{grupo.dias}</dt><dd>{grupo.horas}</dd></div>)}
    {horario && <div><dt>Información adicional</dt><dd>{horario}</dd></div>}
  </dl></details>;
};
